{
  "menu": {
    "title": "Marcaciones"
  },
  "title": "Marcaciones",
  "description": "Entradas y salidas registradas en tus sedes.",
  "timezoneHint": "Cada hora se muestra en la zona horaria de su sede.",
  "columns": {
    "when": "Fecha y hora",
    "worker": "Trabajador",
    "type": "Marcación",
    "site": "Sede",
    "status": "Estado",
    "reason": "Motivo",
    "terminal": "Marcador",
    "detail": "Ver detalle"
  },
  "type": {
    "CHECK_IN": "Entrada",
    "CHECK_OUT": "Salida"
  },
  "status": {
    "VALID": "Válida",
    "FLAGGED": "Observada",
    "SUPERSEDED": "Reemplazada",
    "VOIDED": "Anulada"
  },
  "flags": {
    "LOCATION_MISMATCH": "Fuera del radio de la sede",
    "LOCATION_UNAVAILABLE": "Sin ubicación",
    "MISSING_CHECKOUT": "Sin salida",
    "MARKER_OFFLINE": "Marcador sin conexión"
  },
  "flagHelp": {
    "LOCATION_MISMATCH": "La ubicación del teléfono quedó fuera del radio configurado para la sede.",
    "LOCATION_UNAVAILABLE": "El teléfono no entregó una ubicación al momento de marcar.",
    "MISSING_CHECKOUT": "La jornada superó el máximo configurado sin que se registrara la salida.",
    "MARKER_OFFLINE": "El marcador estaba sin conexión y registró la marcación por su cuenta."
  },
  "location": {
    "MATCH": "Dentro del radio de la sede",
    "MISMATCH": "Fuera del radio de la sede",
    "LOW_ACCURACY": "Ubicación poco precisa",
    "UNAVAILABLE": "Sin ubicación",
    "title": "Ubicación",
    "statusLabel": "Estado",
    "distanceLabel": "Distancia",
    "distanceValue": "{meters} m del centro de la sede",
    "accuracyLabel": "Precisión",
    "accuracyValue": "±{meters} m",
    "viewOnMap": "Ver en mapa",
    "viewOnMapHint": "Abre un proveedor externo en una pestaña nueva.",
    "hidden": "Necesitas el permiso de ubicación para ver las coordenadas.",
    "purged": "Las coordenadas se eliminaron el {date} por la política de retención de la empresa.",
    "noData": "Sin datos adicionales de ubicación."
  },
  "mode": {
    "NORMAL": "Marcador con conexión",
    "AUTONOMOUS": "Marcador sin conexión"
  },
  "source": {
    "VPP": "Marcador",
    "MANUAL": "Registro manual"
  },
  "periodSource": {
    "REPORTED": "Reportado por el marcador",
    "INFERRED": "Deducido por Fermin"
  },
  "filters": {
    "legend": "Filtros de marcaciones",
    "fromDay": "Desde",
    "toDay": "Hasta",
    "worker": "Trabajador",
    "workerPlaceholder": "Buscar trabajador",
    "allWorkers": "Todos los trabajadores",
    "site": "Sede",
    "flag": "Motivo de observación",
    "status": "Estado",
    "type": "Marcación",
    "source": "Origen",
    "history": "Mostrar historial completo",
    "allSites": "Todas las sedes",
    "allFlags": "Todos los motivos",
    "allStatuses": "Todos los estados",
    "allTypes": "Entradas y salidas",
    "allSources": "Todos los orígenes",
    "clear": "Limpiar"
  },
  "detail": {
    "title": "Detalle de la marcación",
    "operativeDay": "Día operativo",
    "timezone": "Zona horaria",
    "source": "Origen",
    "location": "Ubicación",
    "accuracy": "Precisión aproximada: {meters} m",
    "flags": "Por qué está observada",
    "noTerminal": "Sin marcador",
    "notFound": "No encontramos esta marcación.",
    "offlineTitle": "Período sin conexión",
    "offlineDescription": "El marcador siguió registrando marcaciones mientras estuvo sin conexión. Este es el período al que pertenece esta marcación.",
    "periodStarted": "Comenzó",
    "periodEnded": "Terminó",
    "periodDuration": "Duración",
    "periodMarks": "Marcaciones del período",
    "periodSource": "Origen del período",
    "periodOpen": "Todavía sin conexión",
    "framesVerified": "Códigos verificados",
    "framesRequired": "Códigos requeridos",
    "minutes": "{minutes} min",
    "hoursMinutes": "{hours} h {minutes} min",
    "device": "Dispositivo",
    "devicePlatform": "Plataforma",
    "deviceEnrolledAt": "Enrolado el",
    "noDevice": "Registro manual, sin dispositivo",
    "createdBy": "Creada por",
    "reason": "Motivo",
    "voidedTitle": "Anulación",
    "voidedBy": "Anulada por",
    "voidedAt": "Anulada el",
    "voidedReason": "Motivo de la anulación",
    "checkoutWithoutCheckin": "Salida sin entrada previa: el trabajador no tiene una entrada vigente antes de esta salida.",
    "supersededLink": "Ver corrección"
  },
  "chain": {
    "title": "Cadena de correcciones",
    "manualBy": "Corregida por {admin} el {date}",
    "reasonLabel": "Motivo"
  },
  "empty": {
    "title": "Aún no hay marcaciones",
    "description": "Cuando tus trabajadores marquen, aparecerán aquí."
  },
  "noResults": {
    "title": "Sin marcaciones con esos filtros",
    "description": "Prueba con otro rango de fechas, otra sede u otro motivo."
  },
  "error": {
    "title": "No pudimos cargar las marcaciones",
    "description": "Vuelve a intentarlo en un momento."
  },
  "actions": {
    "correct": "Corregir",
    "void": "Anular",
    "correctTitle": "Corregir la marcación de {worker}",
    "correctDescription": "Vas a corregir la marcación de {type} de las {time}. Deja la original como reemplazada.",
    "correctType": "Tipo",
    "correctDate": "Fecha",
    "correctTime": "Hora",
    "correctReason": "Motivo de la corrección",
    "correctReasonHelp": "Explica qué pasó y quién confirma el nuevo valor.",
    "correctSubmit": "Guardar corrección",
    "correctedToast": "Marcación corregida.",
    "voidTitle": "Anular la marcación de {worker}",
    "voidDescription": "Vas a anular la marcación de {type} de las {time}. Dejará de contar en estados, dashboard, historial y reportes.",
    "voidReason": "Motivo de la anulación",
    "voidReasonHelp": "Explica por qué se anula esta marcación.",
    "voidSubmit": "Anular marcación",
    "voidedToast": "Marcación anulada.",
    "reasonRequired": "El motivo es obligatorio.",
    "goToCurrent": "Ver la marcación vigente",
    "notCurrentOutOfScope": "La marcación vigente está fuera de tu alcance."
  },
  "manual": {
    "action": "Nueva marcación manual",
    "title": "Nueva marcación manual",
    "description": "Registra una entrada o salida que no quedó marcada, con motivo obligatorio.",
    "worker": "Trabajador",
    "workerPlaceholder": "Buscar trabajador",
    "site": "Sede",
    "type": "Marcación",
    "date": "Fecha",
    "time": "Hora",
    "reason": "Motivo",
    "reasonHelp": "Explica por qué se registra manualmente esta marcación.",
    "submit": "Crear marcación",
    "workerRequired": "Elige un trabajador.",
    "siteRequired": "Elige una sede.",
    "createdToast": "Marcación manual creada.",
    "flagClearedToast": "Se retiró el aviso de salida pendiente."
  },
  "warnings": {
    "title": "Revisa antes de guardar",
    "description": "Encontramos lo siguiente; puedes continuar si es correcto.",
    "confirm": "Guardar de todos modos",
    "CONSECUTIVE_CHECK_IN": "El trabajador quedará con dos entradas seguidas sin una salida entre medias.",
    "CONSECUTIVE_CHECK_OUT": "El trabajador quedará con dos salidas seguidas sin una entrada entre medias.",
    "SITE_NOT_AUTHORIZED": "El trabajador no está autorizado en esta sede.",
    "BEFORE_ENROLLMENT": "La fecha es anterior al enrolamiento del trabajador."
  },
  "errors": {
    "sameInstant": "Ya existe una marcación vigente de este trabajador en el mismo instante.",
    "idempotencyKeyReused": "Este intento ya se procesó. Vuelve a intentarlo desde el formulario."
  },
  "export": {
    "action": "Exportar",
    "pending": "Exportando…",
    "rangeRequired": "Aplica un rango de fechas (Desde/Hasta) para exportar.",
    "options": {
      "detail-csv": "Detalle · CSV",
      "detail-xlsx": "Detalle · XLSX",
      "summary-csv": "Resumen diario · CSV",
      "summary-xlsx": "Resumen diario · XLSX"
    },
    "toastSuccess": "Descarga lista: {filename}",
    "error": "No pudimos generar la exportación."
  },
  "regularization": {
    "ask": "Pedir regularización",
    "openASKED": "Regularización pedida al trabajador.",
    "openPENDING": "Regularización en revisión: el trabajador propuso una hora.",
    "viewRequest": "Ver solicitud",
    "source": "Creada al aprobar una regularización del trabajador.",
    "viewSource": "Ver solicitud de origen"
  }
}
